export default __webpack_public_path__ + "static/media/BASSLINE  smooth_1.eff7dcc5.wav";